import React from "react"
import { css } from "@emotion/core"
import { Link } from "gatsby"
import DateLabel from "components/UI/DateLabel"
import t from "theme"

const InternalLink = ({ decoration, type = "large", headline, preview, date, pathname, ...props }) => (
    <Link to={pathname} {...props}>
        {decoration ? (
            <div
                css={css`
                    padding-bottom: ${t.space[1]};
                `}>
                {decoration}
            </div>
        ) : null}

        {type === "large" ? (
            <h3>{headline}</h3>
        ) : (
            <div
                css={css`
                    font-size: ${t.font.size[4]};
                `}>
                {headline}
            </div>
        )}
        {date ? <DateLabel date={date} /> : null}
        {preview ? (
            <div
                css={css`
                    margin-top: ${t.space[4]};
                    color: ${t.color.lighttext};
                `}>
                {preview}
            </div>
        ) : null}
    </Link>
)

export default InternalLink

/*

Generate a card that is either:
    - Quite detailed (e.g. article preview)
    - Just has headline
    - Can take care of decorations?

props include:
Decoration
Type (big, small) -> if big, big header font. if small, small header font.
Headline
Date -> if provided, show below headline
Preview-> if provided, show below headline and date
Pathname


<ContentDecoration type={articleType} company={company} date={sortTimestamp} homepage={homepage} />

*/

/*
const Card = ({ headline, shortDescription, sortTimestamp, pathname }) => {
    return (
        <div>
            <div
                css={css`
                    margin-bottom: ${t.space[6]};
                `}>
                <h2>
                    <Link to={pathname}>
                        {headline}
                    </Link>
                </h2>

                <DateLabel date={sortTimestamp} />
            </div>

            <p
                css={css`
                    color: ${t.color.lighttext};
                `}>
                {shortDescription}
            </p>
        </div>
    )
}

export default Card


const FeaturedArticlePreview = ({ slug, companies, articleType, sortTimestamp, headline, homepage }) => {
    const company = companies ? companies[0] : null

    return (
        <div>
            <ContentDecoration type={articleType} company={company} date={sortTimestamp} homepage={homepage} />

            <div>
                <Link to={linkResolver({ slug: slug, type: "article" })}>
                    {headline}
                </Link>
            </div>
        </div>
    )
}

export default FeaturedArticlePreview
*/
